import React from "react";
export default function AuthHero() {
  return <div className="w-full text-center mb-8">
      <h1 className="text-4xl font-bold text-grandpal-green-dark mb-4">Welcome to Grandpal</h1>
      <p className="text-lg text-gray-700 max-w-2xl mx-auto">
        Find and connect with the perfect care home for your loved ones across Ireland.
      </p>
    </div>;
}